import React from 'react';
import Video from '../../Student/Dyslexia/Video';
import FaArrowRight from 'react-icons/lib/fa/arrow-right';
import FaRepeat from 'react-icons/lib/fa/repeat';
import cx from 'classnames';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";

export default class ReadAloudVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      play: false,
      replayCount: 0,
    };

    this.onVideoDone = this.onVideoDone.bind(this);
    this.onReplayClick = this.onReplayClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.isReplayable = this.isReplayable.bind(this);
  }

  componentDidMount() {
    if (this.props.assetURL) {
      this.play();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.assetURL && this.props.assetURL) {
      this.play();
    }
    if (prevProps.assetURL != this.props.assetURL) {
      this.play();
    }
  }

  play() {
    this.setState({...this.state, play: true});
  }

  onVideoDone() {
    this.setState({...this.state, play: false});
  }

  onReplayClick() {
    if(this.isReplayable()){
      this.setState({
        ...this.state,
        play: true,
        replayCount: this.state.replayCount + 1,
      });
    }
  }

  isReplayable() {
    const maxReplays = 1;
    return this.state.replayCount < maxReplays;
  }

  onNextClick() {
    if(!this.state.play){
      this.props.onDone();
    }
  }

  render() {
    const videoOverlayClasses = cx ({
      'readAloudVideoOverlay': !this.state.play,
      'hide': this.state.play,
    });

    const buttonContainerClasses = cx ({
      'videoPlayerButtonContainer': true,
      'fixedInPlace': true,
      'hide': this.state.play,
    });

    const nextButtonClasses = cx ({
      'inactive': this.state.play,
      'readAloudButton': true,
      'next': true,
    });

    const replayButtonClasses = cx ({
      'inactive': this.state.play || !this.isReplayable(),
      'readAloudButton': true,
      'replay': true,
    });

    return (
      <div className="readAloudContainer">
        <div className="readAloudVideoContainer">
          <div className={videoOverlayClasses}></div>
          <div className="readAloudVideo">
            <Video
              videoURL={this.props.assetURL}
              text={this.state.text}
              playVideo={this.state.play}
              allowReplay={true}
              onDone={this.onVideoDone}
              unmountWhenDone={this.props.unmountWhenDone}
              key="readAloudVideo"
              ref="readAloudVideo"
              speech={this.props.speech}
            />
          </div>
          <div className={buttonContainerClasses}>
            <div className={replayButtonClasses} aria-label="Replay video" {...doNotUseAccessibleStaticElementInteractions({onClick: this.onReplayClick})}>
              <FaRepeat size="70" className="buttonSvg replay"/>
              <div className="buttonLabel replay">Replay</div>
            </div>
            <div className={nextButtonClasses} aria-label="Next part" {...doNotUseAccessibleStaticElementInteractions({onClick: this.onNextClick})}>
              <FaArrowRight size="70" className="forward buttonSvg"/>
              <div className="buttonLabel">Next</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
